<template>
  <div class="manuscripts">
    <b-container fluid="xxl">
      <b-row class="text-center">
        <b-col>
          <input
            class="px-2 py-1 w-100"
            id="search"
            type="text"
            size="sm"
            placeholder="Search manuscripts"
            @keyup="getSearchResults()"
            autocomplete="off"
            v-model="query"
          />
        </b-col>
      </b-row>

      <b-row class="mt-3">
        <b-col>
          <ul v-if="manuscripts.length" class="results-ul">
            <li v-for="manuscript in manuscripts" :key="manuscript.id">
              <a href="#" @click="selectManuscript($event, manuscript)" v-html="manuscript.codeRepcrit"></a>
            </li>
          </ul>
          <span v-else class="opacity-60">
            <span v-if="query">No results</span>
            <span v-else>Start searching</span>
          </span>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'ManuscriptAutocomplete',
    props: ['exclude'],
    data() {
      this.$store.state.manuscript.manuscripts = []
      return {
        query: '',
        timer: null
      }
    },
    mounted() {
      this.$store.state.manuscript.manuscripts = []
    },
    computed: {
      ...mapState({
        manuscripts: state => state.manuscript.manuscripts
      }),
      clearQuery(){
        return this.query.replace(/\*/gi, '')
      }
    },
    methods: {
      selectManuscript(event, manuscript){
        event.preventDefault()
        this.$emit('select', manuscript)
        this.$store.state.manuscript.manuscripts = []
        this.query = ''
      },
      getSearchResults(){
        clearTimeout(this.timer)
        // let that = this
        this.timer = setTimeout(() => {
          this.$store.dispatch('searchManuscripts', {
            query: this.query.toLowerCase(),
            exclude: (this.exclude ? this.exclude : [])
          })
        }, 400)
      }
    }
  }
</script>
